import { NgModule } from "@angular/core";

import { CommonModule } from "@angular/common";
import { StorageModule } from "../storage/storage.module";
import { AuthGuard } from "./auth-guard.service";
import { authInterceptorProvider } from "./auth-interceptor.service";
import { AuthTimer } from "./auth-timer";
import { AuthService } from "./auth.service";
import { TIMER_START } from "./auth.token"
import { AuthorizedForRolesDirective } from "./authorized-for-roles.directive";
import { EnabledForRolesDirective } from "./enabled-for-roles.directive";
import { LogoutWarningModule } from "./logout-warning/logout-warning.module";
import { RoleGuard } from "./role-guard";
import { UserRoleService } from "./user-role-service";
import { ActivityMonitorService } from "./activity-monitor.service";

@NgModule({
    imports: [
        StorageModule,
        CommonModule,
        LogoutWarningModule,
    ],
    declarations: [
        AuthorizedForRolesDirective,
        EnabledForRolesDirective,
    ],
    providers: [
        AuthService,
        ActivityMonitorService,
        AuthGuard,
        RoleGuard,
        authInterceptorProvider,
        AuthTimer,
        UserRoleService,
        {provide: TIMER_START,  useValue: 5 * 60 * 1000},
    ],
    exports: [
        AuthorizedForRolesDirective,
        EnabledForRolesDirective,
    ],
})
export class AuthModule { }
